import { Set } from 'api/models/Sets';
import { CheckInTraysBySet } from 'hooks/useCheckInTraysBySet';
import { CheckOutTraysBySet } from 'hooks/useCheckOutTraysBySet';
import { useCallback } from 'react';

export const useGetRemainingSets = () => {
  const getRemainingSets = useCallback(
    (stage: 'CHECK_IN' | 'CHECK_OUT', sets: Set[], traysBySet?: CheckOutTraysBySet | CheckInTraysBySet) =>
      sets.filter(set => {
        // members are checked in/out through their consolidated set, so they never count as remaining
        if (set.consolidatedIntoKitInstanceId) return false;

        const completedInState =
          traysBySet?.[set.kitInstanceId]?.trays &&
          Object.values(traysBySet[set.kitInstanceId].trays).every(tray => tray.completed);
        return !completedInState && set.inspections?.[stage]?.status != 'CONFIRMED';
      }),
    [],
  );

  return getRemainingSets;
};
